import React from 'react';
import { Dialog, DialogContent, Typography, Box, Button, DialogTitle, Icon, CircularProgress } from '@material-ui/core';

import { Check, HighlightOff } from '@material-ui/icons';
import Transition from 'shared/components/Transition';

import { useDialogStyles } from '../styles';
import { useSelector } from 'react-redux';

interface StakeProps {
  open: boolean;
  handleClose: () => void;
  handleButton: (error: boolean) => void;
}

const WithdrawDialog = (props: StakeProps) => {
  const { open, handleClose, handleButton } = props;

  const dialogClasses = useDialogStyles();

  const loading = useSelector(state => state.pool.withdrawLoading);
  const error = useSelector(state => state.pool.withdrawError);

  let buttonLabel = 'Start'
  const text = 'Please approve the Withdraw transaction in your wallet';

  let stakeIcon = <CircularProgress />

  if (loading) {
    buttonLabel = 'In Progress...';
  } else if (!loading && !error) {
    buttonLabel = 'Done';
    stakeIcon = <Check color='primary' />
  } else if (!loading && error) {
    buttonLabel = 'Try Again';
    stakeIcon = <HighlightOff color='primary' />
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
      className={dialogClasses.processDialogs}
    >
      <DialogTitle className={dialogClasses.dialogTitle}>
        <Typography variant='h3'>Withdraw</Typography>
      </DialogTitle>
      <DialogContent className={dialogClasses.proceesContent}>
        <Box>
          <Box display="flex" alignItems="center">
            <Box className={dialogClasses.processIcon}>
              {stakeIcon}
            </Box>
            <Box mt={2} mb={3} ml={3.5}>
              <Typography className={dialogClasses.processText}>{text}</Typography>
            </Box>
          </Box>
          <Box mb={5}>
            <Button onClick={handleButton.bind(null, error)} variant="contained" disabled={loading}>
              {buttonLabel}
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default WithdrawDialog;
